module.exports = __webpack_public_path__ + "img/piaoyuanguanli.8b228793.png";